import { t } from "i18next";
import { Media } from "./media";

export interface Modality {
    id: number;
    name: string;
    speciality_id: number;
    speciality_name: string;
    description: string;
    gender: string;
    distance: number;
    boat: string;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyModality: Modality = {
    id: 0,
    name: '',
    speciality_id: 0,
    speciality_name: '',
    description: '',
    gender: '',
    distance: 0,
    boat: '',
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export const genderOptions = [
    {
        value: 'M',
        label: "Men"
    },
    {
        value: 'H',
        label: "Women"
    },
    {
        value: 'X',
        label: "Mixt"
    }
]
